"use strict";

exports.__esModule = true;
exports.ElementEditorSidebar = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _ElementTree = require("../ElementTree");
var _ElementControls = require("../ElementControls");
var _ControlGroups = require("../ControlGroups");
var _Theme = require("../../../Theme");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Container = _styledComponents["default"].aside.withConfig({
  displayName: "ElementEditorSidebar__Container",
  componentId: "sc-1va1phc-0"
})(["grid-area:sidebar;display:flex;flex-direction:column;overflow:auto;padding:0 0 ", " 0;background:", ";box-shadow:rgba(0,0,0,0.5) -20px 2px 35px -19px;z-index:5;"], (0, _Theme.val)("ToolbarHeight"), (0, _Theme.val)("RightEditPanelBackground"));
var SidebarTree = (0, _styledComponents["default"])(_ElementTree.ElementTree).withConfig({
  displayName: "ElementEditorSidebar__SidebarTree",
  componentId: "sc-1va1phc-1"
})(["flex:1;"]);

/**
 * Shows the sidebar in the element editor.
 */
var ElementEditorSidebar = exports.ElementEditorSidebar = /*#__PURE__*/function (_Component) {
  function ElementEditorSidebar() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(ElementEditorSidebar, _Component);
  var _proto = ElementEditorSidebar.prototype;
  _proto.render = function render() {
    var elementEditor = this.props.elementEditor;
    var controlPaths = elementEditor.getControlPaths();
    return /*#__PURE__*/_react["default"].createElement(Container, {
      "data-testid": "ElementEditorSidebar"
    }, /*#__PURE__*/_react["default"].createElement(_ElementControls.ElementControls, {
      elementEditor: elementEditor,
      controlPaths: controlPaths
    }), /*#__PURE__*/_react["default"].createElement(SidebarTree, {
      "data-testid": "ElementEditorSidebarTree",
      widgets: elementEditor.widgets,
      rootElement: elementEditor.rootElement,
      selectedPath: elementEditor.selectedPath,
      onSelect: elementEditor.selectElementAt
    }));
  };
  return ElementEditorSidebar;
}(_react.Component);